const template1DataConverter = ({ styleSettings, selectedNews, newsList }) => {
  return {
    openingSlide: {
      logo: styleSettings?.openingSlide?.logo?.url || "",
      backgroundColor: styleSettings?.openingSlide?.backgroundColor || "#fff",
    },
    slideItems: selectedNews.map((newsId) => {
      const news = newsList.find((news) => news.id === newsId);
      return {
        title: {
          text: news.title ?? "",
          font: styleSettings?.slideItem?.title?.font ?? "",
          color: styleSettings?.slideItem?.title?.color ?? undefined, // optional
          backgroundColor: styleSettings?.slideItem?.title?.backgroundColor ?? undefined, // optional
        },
        category: {
          text: (news.category ?? "").slice(0, 25), // max 25
          font: styleSettings?.slideItem?.category?.font ?? "",
          color: styleSettings?.slideItem?.category?.color ?? "",
          backgroundColor: styleSettings?.slideItem?.category?.backgroundColor ?? "",
        },
        voiceText: (news.voiceText ?? ""),
        imageUrl: (news.image ?? ""),
      };
    }),
  };
};

const TEMPLATE1_DEFAULT_STYLE_SETTINGS = {
  openingSlide: {
    logo: {
      url: "",
    },
    backgroundColor: "#ffffff",
  },
  slideItem: {
    title: {
      color: "#000000",
      font: "",
      backgroundColor: "#ffffff",
    },
    category: {
      color: "#000000",
      font: "",
      backgroundColor: "#ffffff",
    },
  },
};

export { template1DataConverter, TEMPLATE1_DEFAULT_STYLE_SETTINGS };
